module.exports = __webpack_public_path__ + "img/code_img1.fbfb8c6f.png";